import { MatMenuModule } from '@angular/material/menu';
import { NvTextboxModule } from '../../../nvps-libraries/design/nv-textbox/nv-textbox.module';
import { TilesModule } from './tiles/tiles.module';
import { NetworkTilesMadLibComponent } from './network-tiles-mad-lib/network-tiles-mad-lib.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NetworkTopLevelComponent } from './network-top-level.component';
import { NetDashTileDataService } from './net-dash-tile-data/net-dash-tile-data.service';

@NgModule({
  declarations: [NetworkTopLevelComponent, NetworkTilesMadLibComponent],
  imports: [CommonModule, TilesModule, NvTextboxModule, MatMenuModule],
  exports: [NetworkTopLevelComponent],
  providers: [NetDashTileDataService],
})
export class NetworkTopLevelModule {
  //
}
